
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import heroImg from '../../../assets/lodhaGoa/mainFeed.jpeg'
import logo from '../../../assets/lodhaGoa/logo.jpeg'


import ameneties1 from '../../../assets/lodhaGoa/ameneties-1.jpeg'
import ameneties2 from '../../../assets/lodhaGoa/ameneties-2.jpeg'
import ameneties3 from '../../../assets/lodhaGoa/ameneties-3.jpeg'
import ameneties4 from '../../../assets/lodhaGoa/ameneties-4.jpeg'
import ameneties5 from '../../../assets/lodhaGoa/ameneties-5.jpeg'
import ameneties6 from '../../../assets/lodhaGoa/ameneties-6.jpeg'
import ameneties7 from '../../../assets/lodhaGoa/ameneties-7.jpeg'
import ameneties8 from '../../../assets/lodhaGoa/ameneties-8.jpeg'
import ameneties9 from '../../../assets/lodhaGoa/amenities-9.jpeg'
import ameneties10 from '../../../assets/lodhaGoa/ameneties-10.webp'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const LodhaGoa = () => {
  const location = useLocation();
  const [openImgModal, setOpenImgModal] = useState(false);
  const [selectedImgIndex, setSelectedImgIndex] = useState(null);

  const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5, ameneties6, ameneties7, ameneties8, ameneties9, ameneties10]

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);


  const handleOpenModal = (index) => {
    setSelectedImgIndex(index);
    setOpenImgModal(true);
  }

  return (
    <div className="w-full min-h-screen bg-gray-100 mt-5">
      <div
        className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
        style={{ backgroundImage: `url('${heroImg}')` }}
      ></div>

      <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
        <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
          <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
        </div>
      </div>

      <div class="flex flex-col md:flex-row px-2.5 gap-4">
        <div class="w-full md:w-2/3 flex flex-col gap-4">
          <div className="">
            <div className="max-w-5xl mx-auto p-6">
              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                The <strong>House of Abhinandan Lodha's Goa Project</strong>, also known as <strong>One Goa,</strong> is a premium
                residential development located in Bicholim, Goa. This project offers a unique opportunity for land
                ownership in one of India's most beloved states. Here are some highlights:
              </p>

              <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Development Size:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Spread across 130+ acres, this is a gated community designed to provide a
                    luxurious lifestyle.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Amenities:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project boasts over 25 luxury amenities, including two exceptional
                    clubhouses—Club La Coral and Club La Pearl. These are designed for holistic well-being and
                    recreation. Additional features include a 5-star luxury hotel, branded gym, swimming pool,
                    amphitheater, sports arena, and more.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Central Park:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A 20+ acre central park with a man-made sea and beach adds to the charm of
                    this development.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Connectivity:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project is strategically located, offering easy access to key destinations like
                    Mopa Airport (45 minutes), Panaji (25 minutes), and popular beaches like Baga and Candolim (45
                    minutes).
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Investment Opportunity:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    With Goa's limited land availability and rising demand, this project
                    represents a significant investment opportunity. Prices for plots start at ₹95 lakhs for 1500 sq. ft. and
                    ₹1.15 crores for 1800 sq. ft.
                  </p>
                </div>
              </section>
              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                This development combines luxury, convenience, and the natural beauty of Goa, making it an
                attractive option for both residents and investors. You can explore more about it
                <a href="https://www.abhinandanlodhaonegoa.in/" className='text-blue-500'> here</a> or <a href="https://hoablprojects.com/goa/" className='text-blue-500'>here</a>
              </p>
            </div>
          </div>
        </div>
        <ConnectForm />
      </div>
      <div className="max-w-7xl mx-auto p-4">
        <h2 className="text-2xl font-semibold text-gray-800 my-4">
          Projects Highlights
        </h2>
        {openImgModal && (
          <ImageModal
            images={ameneties}
            openImg={openImgModal}
            selectedImgIndex={selectedImgIndex}
            onClose={() => setOpenImgModal(false)}
          />
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {ameneties.map((data, index) => (
            <div
              key={index}
              onClick={() => handleOpenModal(index, "ameneties")}
              className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
            >
              <img
                src={data}
                alt="ATS"
                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default LodhaGoa